var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViberLogoEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 685.3 685.3",
    style: {
      enableBackground: "new 0 0 685.3 685.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.4,272.1c-3.7,0-6.7-3-6.7-6.8c0,0,0-0.1,0-0.1c0-3.8,3.1-6.8,6.8-6.8c0.1,0,37.9,0,40.3,41.5 c0.3,3.7-2.6,7-6.3,7.2c-3.7,0.3-7-2.6-7.2-6.3c0-0.1,0-0.1,0-0.2C384.6,272.1,359.4,272.1,359.4,272.1L359.4,272.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.3,240.6c-3.8-0.1-6.7-3.3-6.6-7.1c0.1-3.8,3.3-6.7,7.1-6.6l0,0c0.2,0,77.8,2.2,77.8,85 c0,3.8-3.1,6.9-6.8,6.9c-3.8,0-6.9-3.1-6.9-6.9C414.9,242.4,350.4,240.5,350.3,240.6L350.3,240.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.5,210.4c-3.8,0.1-7-2.8-7.1-6.6c-0.2-3.7,2.6-6.9,6.3-7.1c0.1,0,0.1,0,0.2,0c0.3,0,117.9-6.5,122.2,127.2 c0.1,3.8-2.8,7-6.6,7.1c-3.8,0.1-7-2.8-7.1-6.6C442.7,204.5,338.8,210.3,338.5,210.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.8,213.9c0,0,12.3-7.6,19.1,2.7l33.7,44.5c0,0,6.2,11-2.1,17.8l-17.8,13c0,0-8.2,2.8-1.3,17.1 c0,0,22.6,51.5,71.9,71.3c0,0,8.3,4.1,18.5-2.1l13.7-15c0,0,9.6-9,19.1,0.7l42.5,30.8c0,0,8.3,5.4,1.4,17.8c0,0-18.5,20.5-28.8,26 c0,0-9.6,6.1-25.4,0.7c0,0-79.5-32.2-118.6-82.9c0,0-25.3-25.4-54.8-94.6c0,0-3.4-12.3,4.8-22L249.8,213.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.1,515.4v52.8c0,0,2,24.7,16.4,25.3c0,0,7.6,2.1,17.8-10.3l47.2-54.1c61.8,5.8,128.3,3.8,185.3-22.3 c26.3-12.2,69.2-42.4,77.2-112.7c0,0,15.7-99.3-3.4-168c0,0-31-93.9-111.7-109.6c0,0-114.5-26.1-214.6-0.7 c0,0-110.3,19.1-123.3,138.4c0,0-13,90.5,10.3,173.4C124.4,427.6,155.2,506.5,223.1,515.4L223.1,515.4z M236.8,486.6v84.3 c0,0-0.4,10.6,11.2,1.7c0,0,16.9-17.4,61.4-74.3c0,0,64.4,4.8,128.9-10.3c0,0,87-17.8,94.5-100c0,0,9.7-85-2-146 c0,0-30.1-95.3-128.1-99.5c0,0-114.5-8.9-165.2,8.3c0,0-68.5,15.7-84.9,95.3c0,0-18.5,95.9,2.7,159.7 C155.2,405.8,171.6,469.5,236.8,486.6L236.8,486.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViberLogoEmpty);
export default __webpack_public_path__ + "static/media/viber-logo-empty.96c088fd036a321097157f8676b32445.svg";
export { ForwardRef as ReactComponent };